<template>
  <v-app-bar
    color="teal darken-3"
    dark
    app
    height="40"
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    fixed
  >
    <v-toolbar-title class="ml-0 pl-3">
      <v-app-bar-nav-icon @click.stop="change_drawer" />
      <span class="hidden-sm-and-down">{{ title }}</span>
    </v-toolbar-title>
    <v-spacer />
    <h3 class="user-fio">
      {{ user.first_name }} {{ user.last_name }}
    </h3>
    <a
      class="exit-lnk"
      href="#"
      @click="logout"
    >
      Выход
    </a>
    <v-menu
      v-model="releaseVersion"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-btn
          rounded
          icon
          v-on="on"
        >
          <v-icon color="white">
            far fa-question-circle
          </v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-text><a href="#">Справка ПО "АСКУЭ"</a></v-card-text>
        <v-divider />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <a href="/release-notes">Релиз 1.5.2</a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default () {
        return [{ 'index': '1', 'option': 'Помощь' }, { 'index': '1', 'option': 'Admin' }]
      }
    }
  },
  data () {
    return {
      user: {},
      releaseVersion: false
    }
  },
  mounted () {
    this.axios.get(`/api/users/me/`).then((response) => {
      this.user = response.data
      if (!this.user.is_stuff) {
        this.$router.push('/login')
      }
    })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    change_drawer () {
      this.$emit('change_drawer')
    },
    logout () {
      localStorage.removeItem('token')
      this.$store.commit('LOGOUT_USER')
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style scoped>
  .small-title .v-list-item {
      height: unset;
  }
  .v-app-bar >>> .v-toolbar__content {
    height: 40px !important;
    padding-left: 0px;
  }
  .v-app-bar {
    box-shadow: none;
  }
  .exit-lnk {
    color: white;
    text-decoration: none
  }
  .user-fio {
    padding-right: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/Toolbar.vue